import { Button, ChevronLeft, ChevronRight } from "@repo/ui";

export type NavigationControlsProps = {
  onMoveLeft: () => void;
  onMoveRight: () => void;
};

export const NavigationControls = ({ onMoveLeft, onMoveRight }: NavigationControlsProps) => (
  <>
    <Button
      icon={<ChevronLeft className="h-4 w-4" />}
      variant="outline"
      align="center"
      justify="center"
      onClick={onMoveLeft}
      className="rounded-full"
      title="Move panel to left"
    />
    <Button
      icon={<ChevronRight className="h-4 w-4" />}
      variant="outline"
      align="center"
      justify="center"
      onClick={onMoveRight}
      className="rounded-full"
      title="Move panel to right"
    />
  </>
);
